// extracted by mini-css-extract-plugin
export default {"videoBg":"BackgroundAnimation_videoBg__NIOfO","lightBg":"BackgroundAnimation_lightBg__UXksk"};